<template>
  <div>
    <el-card>
      <div class="flex flex-align-center flex-wrap gap-20">
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel">关键字：</div>
          <el-input v-model="keywords" placeholder="分销商名称、分销商帐号" style="width:250px"></el-input>
        </div>
        <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
        <buttonPermissions :datas="'XITAIDistributionManageEdit'">
          <el-button type="primary" @click="editRow({})">添加</el-button>
        </buttonPermissions>
      </div>
      <div class="margin-top-10">
        <el-table :data="tablelist" v-loading="tableloading">
          <el-table-column prop="EmployeeName" label="分销商">
            <template slot-scope="scope">
              <div class="ellipsis">{{scope.row.EmployeeName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="DistributionLevelValue" label="分销级别"></el-table-column>
          <el-table-column prop="Phone" label="登录帐号"></el-table-column>
          <el-table-column prop="EmployeeStateValue" label="分销商状态"></el-table-column>
          <el-table-column prop="AddTime" label="添加时间"></el-table-column>
          <el-table-column prop="" label="操作" width="120">
            <template slot-scope="scope">
              <div class="flex flex-align-center gap-10">
                <buttonPermissions :datas="'XITAIDistributionManageEdit'" v-if="scope.row.EmployeeState!=0">
                  <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                </buttonPermissions>
                <buttonPermissions :datas="'XITAIDistributionManageStop'" v-if="scope.row.EmployeeState!=0">
                  <el-button type="text" style="color:#f56c6c" @click="stop(scope.row)">停用</el-button>
                </buttonPermissions>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align:right;margin-top:10px" v-if="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :visible.sync="editShow" :title="rowmsg.Id?'编辑分销商':'添加分销商'" custom-class="dialog-body-paddingTop-10" width="500px" v-loading="editLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center">
          <div class="form-label label-star">分销商级别：</div>
          <el-radio-group v-model="rowmsg.DistributionLevel" style="margin-top:3px">
            <el-radio :label="1">一级分销</el-radio>
            <el-radio :label="2">二级分销</el-radio>
          </el-radio-group>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star">分销商名称：</div>
          <el-input v-model="rowmsg.EmployeeName" placeholder="分销商名称" maxlength="50"></el-input>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star">登录账号：</div>
          <el-input v-model="rowmsg.Phone" placeholder="分销商登录帐号" maxlength="11" :disabled="rowmsg.Id>0"></el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="editShow=false">关闭</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import {
  cittaDistributiondistributorList,
  cittaDistributiondistributorInfo,
  cittaDistributiondistributorSave,
} from "@/api/sv3.0.0"
import {
  employeedeparture
} from '@/api/api'
export default {
  components: {
    buttonPermissions
  },
  data () {
    return {
      keywords:'',
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pagesize:20,
      total:0,
      rowmsg:{},
      editShow:false,
      editLoading:false,
    }
  },
  mounted () {
    this.gettablelist()
  },
  methods: {
    stop(row){
      this.$confirm('是否确认停用分销商帐号？停用后分销商不可再登录系统，不影响分销商已录入的订单数据。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(async () => {
        try{
          this.editLoading = true
          let res = await employeedeparture({Id:row.Id})
          if(res.IsSuccess){
            this.$message.success('操作成功')
            this.gettablelist()
          }
        }finally{
          this.editLoading = false
        }
      })
    },
    async confirm(){
      if(!this.rowmsg.DistributionLevel){
        this.$message.error('请选择分销商级别')
        return
      }else if(!this.rowmsg.EmployeeName){
        this.$message.error('请输入分销商名称')
        return
      }else if(!this.rowmsg.Phone){
        this.$message.error('请设置分销商登录账号')
        return
      }
      try{
        this.editLoading = true
        let res = await cittaDistributiondistributorSave({
          CittaDistributorInfo:this.rowmsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.editShow = false
          this.gettablelist()
        }
      }finally{
        this.editLoading = false
      }
    },
    async editRow(row){
      if(!row.Id){
        this.rowmsg = {
          Id:0,
          DistributionLevel:null,
          EmployeeName:'',
          Phone:''
        }
      }else{
        try{
          let res = await cittaDistributiondistributorInfo({
            Id:row.Id
          })
          if(res.IsSuccess){
            this.rowmsg = res.Result
          }
        }finally{
          //
        }
        this.rowmsg = JSON.parse(JSON.stringify(row))
      }
      this.editShow = true
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pagesize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keywords,
          EmployeeState:null,
          Skip:(this.currentPage-1)*this.pagesize,
          Take:this.pagesize,
        }
        let res = await cittaDistributiondistributorList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
}
</script>

<style lang='less' scoped>

</style>